export interface Taggable {
  data: { tags: string[] };
  addTag: (tag: string) => any;
  removeTag: (tag: string) => any;
}

export function isTagContainer(x: unknown): x is { tags: string[] } {
  return (
    x != null && typeof x === 'object' && 'tags' in x && Array.isArray(x.tags)
  );
}

export function isTaggable(x: unknown): x is Taggable {
  return (
    x != null &&
    typeof x === 'object' &&
    'data' in x &&
    'addTag' in x &&
    'removeTag' in x &&
    isTagContainer(x.data) &&
    typeof x.addTag === 'function' &&
    typeof x.removeTag === 'function'
  );
}
